import CustomAttribute from "../CustomAttribute";
import DiscountAllocation from "./DiscountAllocation";
import DiscountApplication from "./DiscountApplication";
import ShopifyVariant from "./ShopifyVariant";

export default class LineItem {
  id?: string;
  quantity?: number;
  title?: string;
  variant?: ShopifyVariant;
  customAttributes: CustomAttribute[] = [];
  discountAllocations?: DiscountAllocation;
  discountApplication?: DiscountApplication;
  productType: string = "";
  groupID: string = "";
  freeGift: string = "";
  constructor(response?: any) {
    if (response != null) {
      this.id = response.id;
      this.quantity = response.quantity;
      this.title = response.title;
      this.variant = new ShopifyVariant(response.variant);
      for (let att of response.customAttributes) {
        this.customAttributes.push(new CustomAttribute(att));
      }
      this.discountAllocations = new DiscountAllocation(
        response.discountAllocations
      );
      this.discountApplication = new DiscountApplication(
        response.discountAllocations
      );
    }
  }
}
